module.exports = __webpack_public_path__ + "static/media/aerologix_black_logo.a03d0fb2.svg";